<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>项目成本管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="客户ID"
                        prop="customerid">
            <el-input placeholder="请输入客户ID"
                      v-model="search.customerid"></el-input>
          </el-form-item>
          <el-form-item label="项目名称"
                        prop="name">
            <el-input placeholder="请输入项目名称"
                      v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="项目编号"
                        prop="number">
            <el-input placeholder="项目编号"
                      v-model="search.number"></el-input>
          </el-form-item>
          <el-form-item label="开始时间"
                        prop="starttime">
            <el-date-picker
              v-model="search.starttime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <!--<el-button icon="sj-icon-export"-->
                     <!--@click="onExportSearch()">导出-->
          <!--</el-button>-->
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>

      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>

      </template>

      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   @click="onExportSearchDetail()">搜索结果导出
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="项目ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="number"
                         label="项目编号"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="项目名称"
                         min-width="120">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="scope.row.id && $router.push({name: '客户批次管理', params: {projectid: scope.row.id},
                       query: {customername: scope.row.name, customerid:  scope.row.customerid, projectname: scope.row.name}})">
              {{scope.row.name}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         label="类型"
                         min-width="90">
           <template slot-scope="scope">
              <span v-for="item in projectOptions.type"
                    v-if="Number(scope.row.type) === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="detail"-->
<!--                         label="描述"-->
<!--                         min-width="90"></el-table-column>-->
        <el-table-column prop="status"
                         label="状态"
                         min-width="90">
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_cost"
                         label="项目总预算(元)">
          <template slot-scope="scope">
            <span >{{scope.row.total_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_cost"
                         label="项目总成本(元)">
          <template slot-scope="scope">
            <span>{{(scope.row.actual_backend_cost + scope.row.actual_frontend_cost + scope.row.actual_label_cost + scope.row.actual_other_cost) | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="platform_fee_user"
                         label="平台管理费"
                         min-width="90">
          <template slot-scope="scope">
            <span >{{scope.row.platform_fee_user | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predict_frontend_cost"
                         label="前端预算">
          <template slot-scope="scope">
            <span >{{scope.row.predict_frontend_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predict_label_cost"
                         label="标注预算">
          <template slot-scope="scope">
            <span >{{scope.row.predict_label_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predict_backend_cost"
                         label="后端预算">
          <template slot-scope="scope">
            <span >{{scope.row.predict_backend_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predict_others_cost"
                         label="其他预算">
          <template slot-scope="scope">
            <span >{{scope.row.predict_others_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actual_frontend_cost"
                         label="实际前端成本">
          <template slot-scope="scope">
            <span >{{scope.row.actual_frontend_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actual_label_cost"
                         label="实际标注成本">
          <template slot-scope="scope">
            <span >{{scope.row.actual_label_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actual_backend_cost"
                         label="实际后端成本">
          <template slot-scope="scope">
            <span >{{scope.row.actual_backend_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actual_other_cost"
                         label="实际其他成本">
          <template slot-scope="scope">
            <span >{{scope.row.actual_other_cost | seperateThousandsToFixed(2)}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="complete_rate"
                         label="项目完成率"
                         min-width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.complete_rate > 0">{{scope.row.complete_rate}}%</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="starttime"
                         label="开始时间"
                         width="190"></el-table-column>
        <!-- <el-table-column prop="endtime"
                         label="结束时间"
                         width="190"></el-table-column> -->
        <el-table-column prop="createtime"
                         label="创建时间"
                         width="190"></el-table-column>

        <el-table-column prop="updatetime"
                         label="最后更新时间"
                         width="190"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../customer-projectcost.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        name: null,
        number: null,
        customerid: null,
        starttime: [],
        type: null
      },
      exportHeader: [
        {
          key: 'id',
          text: '项目ID',
        },
        {
          key: 'customername',
          text: '客户名称',
        },
        {
          key: 'name',
          text: '项目名称',
        },
        {
          key: 'number',
          text: '项目编号',
        },
        {
          key: 'detail',
          text: '描述',
        },
        {
          key: 'budget',
          text: '项目预算',
        },
        {
          key: 'projectcost',
          text: '项目成本',
        },
        {
          key: 'strstatus',
          text: '状态',
        },
        {
          key: 'createtime',
          text: '开始时间',
        },
        {
          key: 'endtime',
          text: '结束时间',
        },
        {
          key: 'createtime',
          text: '添加日期',
        },
        {
          key: 'updatetime',
          text: '最后更新时间',
        },
      ],

      exportHeaderAll: [
        {
          key: 'id',
          text: '项目ID',
        },
        {
          key: 'customername',
          text: '客户名称',
        },
        {
          key: 'name',
          text: '项目名称',
        },
        {
          key: 'number',
          text: '项目编号',
        },
        {
          key: 'execute_rate',
          text: '执行频次',
        },
        {
          key: 'bd',
          text: 'BD',
        },
        {
          key: 'bu',
          text: 'BU',
        },
        {
          key: 'initiator',
          text: '负责人',
        },
        {
          key: 'project_level',
          text: '项目等级',
        },
        {
          key: 'project_category',
          text: '项目分类',
        },
        {
          key: 'target_complete_rate',
          text: '目标完成率',
        },
        {
          key: 'target_market_num',
          text: '目标门店数',
        },
        {
          key: 'createtime',
          text: '开始时间',
        },
        {
          key: 'endtime',
          text: '结束时间',
        },
        {
          key: 'review_group',
          text: '审单归属',
        },
        {
          key: 'distribute_type',
          text: '服务类型',
        },
        {
          key: 'predict_frontend_cost',
          text: '前端预算',
        },
        {
          key: 'predict_label_cost',
          text: '标注预算',
        },
        {
          key: 'predict_backend_cost',
          text: '后端预算',
        },
        {
          key: 'predict_others_cost',
          text: '其他预算',
        },
        {
          key: 'total_cost',
          text: '项目总预算',
        },
        {
          key: 'ticket_predict',
          text: '预估开票金额',
        },
        {
          key: 'gross_rate_predict',
          text: '预估毛利率',
        },
        {
          key: 'executive_budget',
          text: '预估执行成本',
        },
        {
          key: 'is_first_execute',
          text: '项目初次执行',
        },
        {
          key: 'business_process_completed',
          text: '商务流程完备',
        },
        {
          key: 'annual_cooperation_scale',
          text: '年度合作规模',
        },
        {
          key: 'annual_cooperation_times',
          text: '全年合作次数',
        },
        {
          key: 'contract_no',
          text: '所属合同编号',
        },
        {
          key: 'type',
          text: '项目类型',
        },
        {
          key: 'actual_frontend_cost',
          text: '实际前端成本',
        },
        {
          key: 'actual_label_cost',
          text: '实际标注成本',
        },
        {
          key: 'actual_backend_cost',
          text: '实际后端成本',
        },
        {
          key: 'actual_other_cost',
          text: '实际其他成本',
        },
        {
          key: 'platform_fee_user',
          text: '平台管理费',
        },
        {
          key: 'projectcost',
          text: '项目成本',
        },
        {
          key: 'strstatus',
          text: '状态',
        },
        {
          key: 'createtime',
          text: '添加日期',
        },
        {
          key: 'updatetime',
          text: '最后更新时间',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    options: state => state.customerProjectcost.options,
    projectOptions: state => state.customerProject,
    users: state => state.login.user,
  }),
  created () {},
  beforeRouteLeave (to, from, next) {
    // 离开时，清除当前页面设置的查询参数，避免在其他的提现页面保留这些查询参数
    Object.assign(this.$data, this.$options.data.call(this))
    next()
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params.type = this.$route.params.type || 'customer'
      return request.page('getCustomerProjectcostTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          for (let m = 0; m < data.data.length; m++) {
            for (let i = 0; i < this.options.status.length; i++) {
              if (parseInt(data.data[m].status) === this.options.status[i].value) {
                data.data[m].strstatus = this.options.status[i].label
              }
            }
          }
          return data
        },

      })
    },
    onExportSearchDetail () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeaderAll,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          for (let m = 0; m < data.data.length; m++) {
            for (let i = 0; i < this.options.status.length; i++) {
              if (parseInt(data.data[m].status) === this.options.status[i].value) {
                data.data[m].strstatus = this.options.status[i].label
              }
            }
            for (let i = 0; i < this.projectOptions.projectLevel.length; i++) {
              if (parseInt(data.data[m].project_level) === this.projectOptions.projectLevel[i].value) {
                data.data[m].project_level = this.projectOptions.projectLevel[i].label
              }
            }
            for (let i = 0; i < this.projectOptions.reviewGroup.length; i++) {
              if (parseInt(data.data[m].review_group) === this.projectOptions.reviewGroup[i].value) {
                data.data[m].review_group = this.projectOptions.reviewGroup[i].label
              }
            }
            for (let i = 0; i < this.projectOptions.distributeType.length; i++) {
              if (parseInt(data.data[m].distribute_type) === this.projectOptions.distributeType[i].value) {
                data.data[m].distribute_type = this.projectOptions.distributeType[i].label
              }
            }
            for (let i = 0; i < this.projectOptions.type.length; i++) {
              if (parseInt(data.data[m].type) === this.projectOptions.type[i].value) {
                data.data[m].type = this.projectOptions.type[i].label
              }
            }
          }
          return data
        },
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportCustomerProjectcostData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteCustomerProjectcostData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/customer-projectcost/pages/CustomerProjectcostTable.vue